export const getRoadDataByTypeOfRoad = (roads, typeOfRoad) => {
    return roads && roads.toJS().find(road => typeOfRoad === road.value);
};
